import { RotateCcw } from "lucide-react";

type IfcViewerToolbarProps = {
  fileName?: string;
  versionLabel?: string | null;
  expiresAt?: string | null;
  onResetView: () => void;
  disabled?: boolean;
};

function formatExpiry(value?: string | null): string {
  if (!value) return "No share expiry set";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Expiry unavailable";
  return `Link expires ${date.toLocaleString()}`;
}

export default function IfcViewerToolbar({ fileName, versionLabel, expiresAt, onResetView, disabled = false }: IfcViewerToolbarProps) {
  return (
    <header className="ifc-viewer-toolbar">
      <div className="ifc-viewer-toolbar__title">
        <span>IFC Viewer</span>
        <strong>{fileName || "Loading IFC model"}</strong>
        {versionLabel ? <small>Version {versionLabel}</small> : null}
      </div>
      <div className="ifc-viewer-toolbar__actions">
        <span className="ifc-viewer-toolbar__expiry">{formatExpiry(expiresAt)}</span>
        <button type="button" onClick={onResetView} disabled={disabled} title="Reset view" aria-label="Reset view">
          <RotateCcw size={18} />
        </button>
      </div>
    </header>
  );
}
